<template>
    <div>
        <div class="statistics-card-wrap">
            <div class="statistics-card">
                <div class="stat-item">
                    <div class="stat-label">使用总算力</div>
                    <div class="stat-value power-value">{{ usetotal.power_total || 0 }}</div>
                </div>
                <template v-for="item in statisticTypes">
                    <div class="stat-item" :key="item.value">
                        <div class="stat-label">{{ item.label }}</div>
                        <div class="stat-value" :class="item.value === 4 ? 'quota-value' : 'power-value'">
                            {{ usetotal[item.totalKey] == null ? 0 : usetotal[item.totalKey] }}
                        </div>
                    </div>
                </template>
            </div>
        </div>
        <el-form :inline="true" size="small" :model="searchParams" :rules="formRules" ref="searchForm">
            <!-- <el-form-item label="商户ID">
                <el-input v-model="searchParams.merchant_id" placeholder="请输入商户ID" clearable></el-input>
            </el-form-item> -->
            <el-form-item label="统计日期" prop="statistics_at"
                :rules="[{ required: true, message: '请选择费用日期', trigger: 'change' }]">
                <template slot="label">
                    统计日期
                    <el-tooltip class="item" effect="dark" content="统计时间从2026年7月1号开始" placement="top">
                        <i class="el-icon-question" style="margin-left: 5px; cursor: pointer;"></i>
                    </el-tooltip>
                </template>
                <el-date-picker v-model="searchParams.statistics_at" type="daterange" align="right" unlink-panels
                    range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"
                    :picker-options="search_pickerOptions" clearable>
                </el-date-picker>
            </el-form-item>
            <el-form-item label="类型">
                <el-select v-model="searchParams.use_type" clearable placeholder="使用类型" class="w290">
                    <el-option label="使用" :value="1"></el-option>
                    <el-option label="退回" :value="2"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="使用类型">
                <el-select v-model="searchParams.direction_type" clearable placeholder="操作类型" class="w290" multiple
                    collapse-tags filterable>
                    <el-option v-for="item in statisticTypes" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="店铺分组">
                <el-select class="w290" v-model="searchParams.group_id" placeholder="全部分组" clearable multiple
                    collapse-tags filterable>
                    <el-option v-for="item in shopgroupList" :key="item.id" :label="item.name" :value="item.id" />
                </el-select>
            </el-form-item>
            <el-form-item label="商品分组">
                <el-select class="w290" v-model="searchParams.product_group_id" placeholder="全部分组" clearable multiple
                    collapse-tags filterable>
                    <el-option v-for="item in productgroupList" :key="item.id" :label="item.name" :value="item.id" />
                </el-select>
            </el-form-item>

            <el-form-item>
                <el-button type="primary" size="small" @click="handleSearch(1)">查询</el-button>
                <el-button plain size="small" @click="handleReset()">重置</el-button>
            </el-form-item>
        </el-form>
        <div class="table_wrap">
            <el-table :data="tableData" style="width: 100%" v-loading="loading" :key="random + 1">
                <el-table-column label="统计时间" prop="statistics_at" align="center"></el-table-column>
                <!-- <el-table-column label="商户ID" prop="merchant_id" align="center"></el-table-column> -->
                <el-table-column label="资源类型" prop="resource_type" align="center">
                    <template slot-scope="scope">
                        <span>{{ scope.row.direction_type === 4 ? '铺货额度' : '算力' }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="类型" prop="use_type_name" align="center">
                    <template slot-scope="scope">
                        {{ scope.row.use_type === 1 ? '使用' : '退回' }}
                    </template>
                </el-table-column>
                <el-table-column label="使用类型" prop="direction_type_name" align="center">
                    <template slot-scope="scope">
                        {{ getDirectionTypeName(scope.row.direction_type) }}
                    </template>
                </el-table-column>
                <el-table-column label="分组类型" prop="use_type_name" align="center">
                    <template slot-scope="scope">
                        {{ scope.row.direction_type === 4 ? '店铺分组' : '商品分组' }}
                    </template>
                </el-table-column>
                <!-- <el-table-column label="分组名称" prop="group_id" align="center"></el-table-column> -->
                <el-table-column label="分组名称" prop="group_name" align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.group_id === 0">未分组</span>
                        <span v-else-if="[1, 2, 3].includes(scope.row.direction_type)">
                            {{ getGroupName(scope.row.group_id, productgroupList) }}
                        </span>
                        <span v-else-if="scope.row.direction_type === 4">
                            {{ getGroupName(scope.row.group_id, shopgroupList) }}
                        </span>
                        <span v-else>-</span>
                    </template>
                </el-table-column>
                <el-table-column label="使用量" prop="use_num" align="center"></el-table-column>

                <!-- <el-table-column label="创建时间" prop="created_at" align="center"></el-table-column>
                <el-table-column label="修改时间" prop="updated_at" align="center"></el-table-column> -->
            </el-table>
        </div>

        <div class="turn_page">
            <Pagination :total="page_data.total" :page.sync="page_data.page" :limit.sync="page_data.limit"
                @pagination="getList" layout="total, sizes, prev, pager, next, jumper" v-if="page_data.total > 0" />
        </div>
    </div>
</template>

<script>
import { mapActions } from "vuex";
import Pagination from "@/components/pagination/pagination.vue";
export default {
    components: {
        Pagination,
    },
    data() {
        return {
            loading: false,
            random: 0,
            page_data: {
                limit: 10,
                page: 1,
                total: 0,
            },
            tableData: [],
            searchParams: {
                use_type: '',
                direction_type: [],
                group_id: [],
                product_group_id: [],
                statistics_at: [],
            },
            shopgroupList: [],
            productgroupList: [],
            search_pickerOptions: {
                disabledDate(time) {
                    return time.getTime() < new Date('2026-06-30').getTime() || time.getTime() > Date.now();
                },
                shortcuts: [{
                    text: '最近一周',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 8);
                        end.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近30天',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 31);
                        end.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近90天',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 91);
                        end.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
                        picker.$emit('pick', [start, end]);
                    }
                }]
            },
            formRules: {
                statistics_at: [{ required: true, message: '请选择费用日期', trigger: 'change' }]
            },
            usetotal: {
                power_total: 0,
                ai_image_power_total: 0,
                ai_sku_power_total: 0,
                ai_title_power_total: 0,
                quota_total:0,
            },
            statisticTypes: [
                { value: 1, label: 'AI图片检测', totalKey: 'ai_image_power_total' },
                { value: 2, label: 'AISKU替换', totalKey: 'ai_sku_power_total' },
                { value: 3, label: 'AI标题', totalKey: 'ai_title_power_total' },
                { value: 4, label: '铺货额度', totalKey: 'quota_total' },
                { value: 5, label: 'AI白底图', totalKey: 'ai_white_power_total' },
                { value: 6, label: 'AI3:4图', totalKey: 'ai_three_to_four_power_total' },
                { value: 7, label: 'AI视频', totalKey: 'ai_video_power_total' },
                { value: 8, label: '低价SKU检测', totalKey: 'sku_price_power_total' },
                { value: 9, label: 'AI商品标记', totalKey: 'ai_product_mark_power_total' },
                { value: 10, label: 'AI常规白底图', totalKey: 'ai_regular_white_power_total' },
            ],
        }
    },
/*    created() {

    },
    mounted() {
        this.$nextTick(() => {
            this.getList()
        })
    },*/
    methods: {
        ...mapActions({
            getShopBoardGroupList: "shop_board/getShopBoardGroupList",
            getCloudProductGroups: 'ucenter/getCloudProductGroups',
            opGetGroupStatisticsList: 'ucenter/opGetGroupStatisticsList',
        }),
        init(){
          this.setDefaultDateRange()
          this.loadGroupList()
          this.getList()
        },
        // 获取列表数据
        getList() {
            this.$refs.searchForm.validate(valid => {
                if (valid) {
                    this.loading = true
                    let param = { page_size: this.page_data.limit, page: this.page_data.page, ...this.searchParams }
                    // 获取统计分组列表
                    this.opGetGroupStatisticsList({
                        data: param,
                        success: (res) => {
                            this.loading = false
                            if (res.code === 200) {
                                this.tableData = res.data.list || []
                                this.page_data.total = res.data.total || 0
                                this.usetotal = { ...this.usetotal, ...(res.data.usetotal || {}) }
                            } else {
                                this.$message.error(res.message || '获取分组统计信息失败');
                            }
                        }
                    })
                } else {
                    return false
                }
            })

        },
        getGroupName(groupId, groupList) {
            const group = groupList.find(item => item.id === groupId);
            return group ? group.name : '-';
        },
        getDirectionTypeName(directionType) {
            const item = this.statisticTypes.find(type => type.value === Number(directionType));
            return item ? item.label : '-';
        },
        // 搜索
        handleSearch(page) {
            this.page_data.page = page || 1
            this.getList()
        },

        // 重置
        handleReset() {
            this.searchParams = {
                use_type: '',
                direction_type: [],
                group_id: [],
                product_group_id: [],
                statistics_at: [],
            }
            this.setDefaultDateRange()
            this.handleSearch(1)
        },

        // 页码改变
        currentChange(val) {
            this.page_data.page = val
            this.getList()
        },

        // 每页条数改变
        sizeChange(val) {
            this.page_data.page_size = val
            this.getList()
        },
        loadGroupList() {
            this.getShopBoardGroupList({
                data: {},
                success: (res) => {
                    if (res.code === 200) {
                        this.shopgroupList = res.data || [];
                    } else {
                        this.$message.error(res.message || '获取分组失败');
                    }

                }
            })
            // 获取商品分组列表
            this.getCloudProductGroups({
                data: { with_count: 0 },
                success: (res) => {
                    if (res.code === 200) {
                        this.productgroupList = res.data || []
                    } else {
                        this.$message.error(res.message || '获取商品分组失败');
                    }
                }
            })


        },
        setDefaultDateRange() {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 8);
            end.setTime(end.getTime() - 3600 * 1000 * 24);
            this.searchParams.statistics_at = [
                this.formatDate(start),
                this.formatDate(end)
            ];
        },
        formatDate(date) {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        },
    }
}
</script>
<style scoped>
.turn_page {
    display: flex;
    justify-content: flex-end;
    margin-top: 30px;
}

.w290 {
    width: 290px;
}

.statistics-card {
    display: grid;
    grid-template-columns: repeat(6, minmax(0, 1fr));
    gap: 10px 12px;
    background: linear-gradient(135deg, #FB5E5E 0%, #E04B4B 100%);
    border-radius: 8px;
    padding: 12px 16px;
    margin-bottom: 0;
    box-shadow: 0 4px 12px rgba(251, 94, 94, 0.2);
}

.statistics-card-wrap {
    width: 100%;
    max-width: 100%;
    margin-bottom: 20px;
}

.stat-item {
    min-width: 0;
    box-sizing: border-box;
    padding: 7px 8px;
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-radius: 6px;
    background: rgba(255, 255, 255, 0.08);
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.14);
    text-align: center;
}

.stat-label {
    font-size: 13px;
    line-height: 18px;
    color: rgba(255, 255, 255, 0.9);
    margin-bottom: 2px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.stat-value {
    font-size: 21px;
    line-height: 26px;
    font-weight: 600;
    color: #ffffff;
    font-family: 'Arial', sans-serif;
}

@media (max-width: 1200px) {
    .statistics-card {
        grid-template-columns: repeat(3, minmax(0, 1fr));
    }
}

@media (max-width: 600px) {
    .statistics-card {
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 8px;
        padding: 10px;
    }

    .stat-item {
        padding: 6px;
    }

    .stat-label {
        font-size: 12px;
    }

    .stat-value {
        font-size: 19px;
    }
}

.power-value {
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.quota-value {
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

</style>
